<template>
    <div class="rulesPage rulesPage1 A4Container pageBreak_no" style="padding-top:0px;">
        <div class="form">
            <div class="cell-group Letter_to_parents">
                <div style="padding:20px;">

                    <p>
                        <span style="font-size:20px">&nbsp;</span>
                    </p>
                    <p>
                        <span
                            style="position:absolute;z-index:-1895825920;left:0px;margin-left:274px;margin-top:110px;width:125px;height:125px"></span><span
                            style="font-size:20px;font-family:宋体">本协议自双方签字之日起生效，具有法律效力。学生在入学前应认真阅读本协议，并确保了解其中各项内容。如有任何疑问或不明之处，应及时向学校咨询。</span>
                    </p>
                    <p>
                        <span style="font-size:20px">&nbsp;</span>
                    </p>
                    <p>
                        <br />
                    </p>
                    <div class="flexCenter" style="width:100%;">
                        <div style="width:80%;">
                            <div class="formItem flexStart">
                                <div class="label" style="font-size:20px;font-family:宋体">学校（盖章）</div>：
                                <div class="input" style="font-size:20px;font-family:宋体;position:relative"><img
                                        :src="getSealSrc" alt=""
                                        style="position:absolute;width:200px;height:200px;bottom:-60px;left:20px;">
                                </div>
                            </div>
                            <p style="margin-top:30px">
                                <span style="font-size:20px">&nbsp;</span>
                            </p>
                            <div class="formItem flexStart">
                                <div class="label" style="font-size:20px;font-family:宋体">学生（签字）</div>：
                                <div class="input" style="font-size:20px;font-family:宋体;position:relative">
                                    <div style="position:absolute;width:200px;height:60px;bottom:-10px;left:20px;">
                                        <img :src="stuInfo.handsignstu" alt="" style="height:100%">
                                    </div>
                                </div>
                            </div>
                            <p style="margin-top:30px">
                                <span style="font-size:20px">&nbsp;</span>
                            </p>
                            <div class="formItem flexStart">
                                <div class="label" style="font-size:20px;font-family:宋体">监护人（签字）</div>：
                                <div class="input" style="font-size:20px;font-family:宋体;position:relative">
                                    <div style="position:absolute;width:200px;height:60px;bottom:-10px;left:20px;">
                                        <img :src="stuInfo.handsign" alt="" style="height:100%">
                                    </div>
                                   
                                </div>
                            </div>
                            <p style="margin-top:30px">
                                <span style="font-size:20px">&nbsp;</span>
                            </p>
                            <div class="formItem flexStart">
                                <div class="label" style="font-size:20px;font-family:宋体">日期</div>：
                                <div class="input" style="font-size:20px;font-family:宋体;position:relative;padding-left:20px;">{{
                                    stuInfo.cdate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'test3',
    props: {
        stuInfo: {
            type: Object,
            default: {}
        }
    },
    computed: {
      getSealSrc() {
        let {xuezhi} = this.stuInfo
        let src = require('../../../../public/img/xygz.png')
        if (xuezhi) {
          if (xuezhi == '五年高技') {
            src = require('../../../../public/img/lygjg.png')
          } else if (xuezhi.indexOf('高职') > -1) {
            src = require('../../../../public/img/lyggz.png')
          }
        }
        return src;
      }
    },
}
</script>
<style lang="less" type="text/less" scoped>
.formItem {
    margin-top: 10px;
}

.label {
    display: inline-block;
    width: 220px;
    text-align: justify;
    text-align-last: justify;
}

.input {
    margin-left: 10px;
    flex: 1;
    height: 40px;
    border-bottom: 1px solid #303133;
}
</style>